<template>
  <v-btn dark @click="trigger" :loading="loading" class="button">{{ label }}</v-btn>
</template>

<script>
export default {
  props: ['label', 'loading'],
  data: () => ({}),
  methods: {
    trigger() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
.button {
  margin: 0;
  @include mainLinearGradient;
  border-radius: 50px;
  width: 100%;
  height: 50px;
  font-weight: bold;

  cursor: pointer;
}
</style>
